import Back from "../../assets/svgs/LoginSignup/Step1/back.svg";
import {
  BackButton,
  ButtonContainer,
  FlexContainer,
  NextButton,
  SkipButton,
} from "../../styles/PersonalInfoStep";

interface StepFormProps {
  onNext: (e: React.FormEvent) => void;
  onSkip: (e: React.FormEvent) => void;

  onBack?: (e: React.FormEvent) => void;
  children: React.ReactNode;
  showBackButton?: boolean;
}

export const StepFileUploadForm: React.FC<StepFormProps> = ({
  onNext,
  onBack,
  onSkip,
  children,
  showBackButton = true,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent page refresh
    onNext(e); // Call handleNext
  };

  const handleSkip = (e: React.FormEvent) => {
    e.preventDefault(); // Prevent page refresh
    onSkip(e); // Call handleNext
  };

  const handleBack = (e: React.FormEvent) => {
    e.preventDefault();
    if (onBack) {
      onBack(e);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {children}

      <ButtonContainer>
        {showBackButton && (
          <BackButton type="button" onClick={handleBack}>
            <img src={Back} alt="Back" />
          </BackButton>
        )}

        <FlexContainer>
          <SkipButton type="button" onClick={handleSkip}>
            Not now
          </SkipButton>
          <NextButton as="button" type="submit">
            Next
          </NextButton>
        </FlexContainer>
      </ButtonContainer>
    </form>
  );
};
